<h3-tool-mode
  [buttons]="buttons"
  [tool]="tool"
  eventBucket="adjustment"
  [ngModel]="tool.getEditMode()"
  (ngModelChange)="tool.setEditMode($event)"
></h3-tool-mode>
